import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../context/auth";
import { ROUTES } from "../../constants/routes";

const ProtectedRoute = () => {
  const { token } = useAuth();

  return token ? <Outlet /> : <Navigate replace to={ROUTES.HOME_ROUTE} />;
};

export default ProtectedRoute;
